import { buildService } from './decorated-service';

const FONASUContribLimits = buildService('/nasu-svc/service');

export const postFONASUContribLimits = async (
  businessPartyId
): Promise<any> => {
  const payload = businessPartyId && { businessPartyId };

  return FONASUContribLimits.http.post(
    '/customer-ira-contribution-limits',
    payload,
    { ignoreServiceFailure: true }
  );
};
